import styled from '@emotion/styled';
import { rgba } from 'polished';
import theme from '../../themes/default';

export const StyledTrack = styled('div')`
  position: absolute;
  width: 8px;
  right: ${theme.spacing.xxSmall};
  bottom: ${theme.spacing.xxxSmall};
  top: ${theme.spacing.xxxSmall};

  border-radius: 3px;
  // z-index added to make the scrollbar clickable
  z-index: 1400;
`;

export const StyledThumb = styled('div')`
  background-color: ${rgba(theme.color.black, theme.opacity.alpha40)};
  cursor: pointer;
  border-radius: ${theme.borderRadius.medium};
`;
